import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import axios from "axios";
import { ChevronLeft, Mail } from "lucide-react";
import { API } from "../contexts/AuthContext";
import { useTranslation } from "@/i18n";

export const ForgotPasswordPage = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setSent(true);
      toast.success(t('forgot.checkEmail'));
    } catch (err) {
      toast.error(err.response?.data?.detail || "Something went wrong");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="app-container px-8 flex flex-col justify-center min-h-screen">
      <div className="mb-8">
        <button onClick={() => navigate('/login')} className="flex items-center text-gray-500 hover:text-black">
          <ChevronLeft size={20} />
          <span>{t('forgot.backToLogin')}</span>
        </button>
      </div>
      
      <div className="mb-8 text-center relative z-10">
        <h1 className="text-3xl font-bold tracking-tight mb-2">{t('forgot.resetPassword')}</h1>
        <p className="text-gray-500">{t('forgot.wellSend')}</p>
      </div>

      <div className="relative z-10">
        {sent ? (
          <div className="text-center py-8">
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <Mail size={32} className="text-green-600" />
            </div>
            <h2 className="text-xl font-semibold mb-2">{t('forgot.checkYourEmail')}</h2>
            <p className="text-gray-500 mb-6">{t('forgot.sentLinkTo')} <strong>{email}</strong></p>
            <p className="text-sm text-gray-400">{t('forgot.didntReceive')}</p>
            <button 
              onClick={() => setSent(false)}
              className="text-sm text-black font-medium mt-1"
            >{t('forgot.tryAnotherEmail')}</button>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label className="text-sm font-medium text-gray-500 mb-1 block">
                {t('forgot.emailAddress')}
              </label>
              <input
                type="email"
                value={email}
                // Lowercased here, not with CSS: accounts are stored lowercase, so a
                // field that only LOOKS lowercase would misreport what it holds.
                onChange={(e) => setEmail(e.target.value.toLowerCase())}
                className="clean-input"
                placeholder="family@email.com"
                required
                autoFocus
                data-testid="reset-email-input"
              />
              <p className="text-xs text-gray-400 mt-2">{t('forgot.enterAssociated')}</p>
            </div>

            <button 
              type="submit" 
              className="clean-btn-primary w-full"
              disabled={submitting}
              data-testid="send-reset-btn"
            >
              {submitting ? t('login.sending') : t('forgot.sendResetLink')}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};
